import { motion } from "framer-motion";

/**
 * MaskedReveal — wraps children in an overflow-hidden mask and translates from 100%->0
 * Usage:
 *   <MaskedReveal delay={0.1}><span>Line one</span></MaskedReveal>
 */
export default function MaskedReveal({ children, delay = 0, duration = 0.9, className = "", as = "div" }) {
  const MotionTag = motion[as] || motion.div;
  return (
    <span className={`mask-line ${className}`}>
      <MotionTag
        initial={{ y: "110%" }}
        animate={{ y: "0%" }}
        transition={{ delay, duration, ease: [0.76, 0, 0.24, 1] }}
        style={{ display: "block", willChange: "transform" }}
      >
        {children}
      </MotionTag>
    </span>
  );
}
